<script>
import { saveAs } from 'file-saver/FileSaver'
import { toArrayBuffer, formatDate } from 'src/utils'
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "UserWizardFinish",
  data() {
    return {
      currentStep: 1,
    };
  },
  computed: {
    ...mapState('users', {
      open: (state) => state.userWizardModal.open,
      maximized: (state) => state.userWizardModal.maximized
    })
  },
  methods: {
    ...mapMutations(["closeModal"]),
    ...mapMutations("users", ["closeUserWizardModal"]),
    ...mapActions("reports", [ "generateRecruiterReferral"]),
    toggleMaximized() {
      this.maximized = !this.maximized;
    }
  }
};
</script>

<template>
<div class="relative-position layout-padding" >
  <div class="sl-row">
    <div class="sl-col-12">
      <p style="max-width:350px; margin:0 auto" class="text-center">You have completed the new user wizard modal. Finish to close the wizard.</p>
    </div>
  </div>
</div>
</template>

<style lang="stylus">
</style>